// Product FAQ section


// window.addEventListener('load',function(){
//   setTimeout(() => {
//      document.querySelector('body').classList.add("loaded"); 
//   }, 4000)

// });



$(document).ready(function () {

    $(".button.atc").css({"display": "block"});
  

  $(".accordion")
    .find(".accordion-toggle")
    .click(function () {
      $(this).closest(".faq-container").toggleClass("active");
      $(this).next().slideToggle("600");
      $(this).toggleClass("active");
      $(this).siblings(".accordion-content").not($(this).next()).slideUp("600");
    });
  $(".accordion-toggle").on("click", function () {
    $(this).toggleClass("active").siblings().removeClass("active");
  });

  $(".product-form__input label").click(function(){
    let values = $(this).attr("data-option");
    $("#selected-variant-name").text(values);
  })

  $('.cat-slider').slick({
    infinite: true,
    slidesToShow: 1, // Shows a three slides at a time
    slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
    arrows: true,
    dots: true
  });
  
  // for (let i = 0; i < document.querySelectorAll(".cat-img").length; i++){
  //   let topPos = document.querySelectorAll(".cat-img")[i].getBoundingClientRect().top;
  //   console.log(topPos);
  //   $(window).scroll(() => {
  //     if($(window).scrollTop() > topPos){
  //       console.log("abc");
  //       document.querySelectorAll(".cat-img")[i].style.position = "fixed";
  //     }
  //   })
  // }

  if ($("#my-video").length > 0) {
    const video = document.getElementById("my-video");
    const videoMobile = document.getElementById("my-video-mobile");
    const circlePlayButton = document.querySelector("#video-play");
    const circlePauseButton = document.querySelector("#video-pause");
    const muteButton = document.querySelector("#video-unmuted");
    const unmuteButton = document.querySelector("#video-muted");

    function togglePlay() {
      if(window.innerWidth > 576){
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
        }else{
        if (videoMobile.paused || videoMobile.ended) {
        videoMobile.play();
      } else {
        videoMobile.pause();
      }
        }
    }

    function togglePause() {
        video.pause();
        videoMobile.pause();
    }

    function mute(){
      if(window.innerWidth > 576){
        video.muted = true;
      }else{
        videoMobile.muted = true;
      }
      muteButton.style.display = "none";
      unmuteButton.style.display = "block";
    }

    function unmute(){
      if(window.innerWidth > 576){
        video.muted = false;
      }else{
        videoMobile.muted = false;
      }
      muteButton.style.display = "block";
      unmuteButton.style.display = "none";
    }

    circlePlayButton.addEventListener("click", togglePlay);
    circlePauseButton.addEventListener("click", togglePause);
    muteButton.addEventListener("click", mute);
    unmuteButton.addEventListener("click", unmute);
    video.addEventListener("playing", function () {
      circlePlayButton.style.display = "none";
      circlePauseButton.style.display = "block";
    });
    video.addEventListener("pause", function () {
      circlePlayButton.style.display = "block";
      circlePauseButton.style.display = "none";
    });

  videoMobile.addEventListener("playing", function () {
      circlePlayButton.style.display = "none";
      circlePauseButton.style.display = "block";
    });
    videoMobile.addEventListener("pause", function () {
      circlePlayButton.style.display = "block";
      circlePauseButton.style.display = "none";
    });

  }
});



